import { Mapper } from "../../../../base/utils/mapper";

import { OriginModel } from "../../../../domain/models/consult/origin.model";
import { OriginEntity } from "../entities/origin.entity";

export class OriginImplementationRepositoryMapper extends Mapper<OriginEntity, OriginModel> {
    mapFrom(param: OriginEntity): OriginModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: OriginModel): OriginEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}